import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./AllYad2TaxiForSalelist.css";

const AllYad2TaxiForSalelist = ({
  manufacturer,
  minKm,
  maxKm,
  minPrice,
  maxPrice,
  showWithoutPrice,
  limitStart = 0,
  limitCount
}) => {
  const [taxis, setTaxis] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTaxis = async () => {
      try {
        setLoading(true);

        // בניית URL עם כל הפילטרים
        const query = new URLSearchParams();

        if (manufacturer) query.append("manufacturer", manufacturer);
        if (minKm) query.append("minKm", minKm);
        if (maxKm) query.append("maxKm", maxKm);
        if (minPrice) query.append("minPrice", minPrice);
        if (maxPrice) query.append("maxPrice", maxPrice);
        if (showWithoutPrice) query.append("showWithoutPrice", "true");

        const url = `/api/taxiforsale?${query.toString()}`;
        const response = await fetch(url);
        const data = await response.json();

        console.log("Fetched taxis:", data);
        setTaxis(data);
      } catch (error) {
        console.error("Error fetching taxis:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTaxis();
  }, [manufacturer, minKm, maxKm, minPrice, maxPrice, showWithoutPrice]);

  if (loading) return <div>טוען מוניות...</div>;
  if (taxis.length === 0) return <div>לא נמצאו מוניות התואמות את הסינון</div>;

  const displayedTaxis = limitCount
    ? taxis.slice(limitStart, limitStart + limitCount)
    : taxis;

  return (
    <div className="all-yad2taxiforsale-container">
      {displayedTaxis.map((taxi) => (
        <Link to={`/taxi/${taxi.id}`} key={taxi.id} className="taxi-card">
          <img src={taxi.תמונות?.[0]} alt={taxi.דגם} className="taxi-image" />
          <div className="taxi-details">
            <div className="taxi-details-Title">
              <h3>{taxi.יצרן} {taxi.דגם}</h3>
            </div>
            <div className="taxi-more-details">
              <p>{taxi.שנתון}</p>
              <p>{taxi.אזור_מגורים}</p>
              <p>{taxi.בעלות}</p>
            </div>
          </div>

          <div className="yad2taxiforsalelistdiv-price">
            {Number(taxi.מחיר) <= 4 ? (
              <p className="no-price-message-list">המפרסם פירסם ללא מחיר</p>
            ) : (
              <>
                <p className="yad2taxiforsalelist-price">{taxi.מחיר} ₪</p>
                <h3 className="yad2taxiforsalelistdiv-priceh3">המחיר לא כולל מע"מ</h3>
              </>
            )}
          </div>
        </Link>
      ))}
    </div>
  );
};

export default AllYad2TaxiForSalelist;
